import type { TFunction } from "i18next";
import type { CompanySettingsAccess } from "~/auth/roleChecks";
import type { FusionMenuConfig, FusionSectionDef } from "~/components/dock/FusionMenu";

import { ApplicationEnum } from "~/@types/enums";

const buildAdminFusionConfig = (
	{
		canManageDevices,
		canManageEmail,
		canManageSecurity,
		canManageUsers,
		canViewBilling,
		canViewGeneral,
		canViewIntegrations
	}: CompanySettingsAccess,
	t: TFunction<"common">,
	canManageParentCompany = false
): FusionMenuConfig => {
	const section = (id: string, label: string, icon: string): FusionSectionDef => ({
		groups: [{ items: [{ icon, pageId: id }] }],
		icon,
		id,
		label
	});

	const sections: FusionSectionDef[] = [
		...(canViewGeneral ? [section("general", t("dock.pages.admin.general"), "tune")] : []),
		...(canViewBilling ? [section("billing", t("dock.pages.admin.billing"), "credit_card")] : []),
		...(canViewIntegrations ? [section("integrations", t("nav.system.integrations.label"), "hub")] : []),
		...(canManageUsers ? [section("users", t("nav.system.users.label"), "group")] : []),
		...(canManageEmail ? [section("email", t("dock.pages.admin.email"), "mail")] : []),
		...(canManageDevices ? [section("devices", t("dock.pages.admin.devices"), "sensors")] : []),
		...(canManageUsers ? [section("data-management", t("nav.system.dataManagement.label"), "fact_check")] : []),
		...(canManageSecurity ? [section("security", t("dock.pages.admin.security"), "shield")] : []),
		...(canManageParentCompany ? [section("parent-company", t("settings.parentCompany.navLabel"), "apartment")] : [])
	];

	return {
		hideLayouts: true,
		logo: "/logos/admin.svg",
		module: ApplicationEnum.ADMIN,
		sections
	};
};

export default buildAdminFusionConfig;
